import { Navigate, Route, Routes } from "react-router-dom";
import { ShowRankingsApple } from "./show-rankings-apple";
import { ShowRankingsAppleMonths } from "./show-rankings-apple-months";
import { ShowRankingsLayout } from "./show-rankings-layout";
import { ShowRankingsPodtrac } from "./show-rankings-podtrac";
import { ShowRankingsSpotify } from "./show-rankings-spotify";
import { ShowRankingsAppleDetail } from "./show-rankings-apple-detail";
import { ShowRankingsSpotifyMonths } from "./show-rankings-spotify-months";
import { ShowRankingsSpotifyDetail } from "./show-rankings-spotify-detail";

export function ShowRankingsRoutes() {
    return (
        <Routes>
            <Route element={<ShowRankingsLayout />}>
                <Route path="podtrac" element={<ShowRankingsPodtrac />} />
                <Route path="apple" element={<ShowRankingsAppleMonths />}>
                    <Route path=":month" element={<ShowRankingsApple />} />
                </Route>
                <Route
                    path="apple/:iTunesID/:iTunesCode/:countryCode"
                    element={<ShowRankingsAppleDetail />}
                />
                <Route path="spotify" element={<ShowRankingsSpotifyMonths />}>
                    <Route path=":month" element={<ShowRankingsSpotify />} />
                </Route>
                <Route
                    path="spotify/:spotifyID/:chart/:countryCode"
                    element={<ShowRankingsSpotifyDetail />}
                />
                <Route index element={<Navigate to="podtrac" replace />} />
            </Route>
        </Routes>
    );
}
